import React from 'react'
import RegistrationSearchContainer from './RegistrationSearchContainer'

const RegistrationSearch = props => (
  <RegistrationSearchContainer {...props} data-test="component-tradeIn-registrationSearch" />
)

export default RegistrationSearch
